// 数据缓存模块，用于存储需要在多个页面共享的数据
const state = {
  // 首页轮播图数据
  homeCarouselData: [],
  // 产品中心轮播图数据
  productCarouselData: [],
  // 首页经典案例轮播图数据
  homeCaseCarouselData: [],
  // 行业分类列表数据
  industryListData: [],
};

const mutations = {
  // 设置首页轮播图数据
  SET_HOME_CAROUSEL_DATA(state, data) {
    state.homeCarouselData = data;
    // 同时存储到localStorage
    localStorage.setItem("homeCarouselData", JSON.stringify(data));
  },

  // 设置产品中心轮播图数据
  SET_PRODUCT_CAROUSEL_DATA(state, data) {
    state.productCarouselData = data;
    // 同时存储到localStorage
    localStorage.setItem("productCarouselData", JSON.stringify(data));
  },

  // 设置行业分类列表数据
  SET_INDUSTRY_LIST_DATA(state, data) {
    state.industryListData = data;
    // 同时存储到localStorage
    localStorage.setItem("industryListData", JSON.stringify(data));
  },

  // 设置首页经典案例轮播图数据
  SET_HOME_CASE_CAROUSEL_DATA(state, data) {
    state.homeCaseCarouselData = data;
    // 同时存储到localStorage
    localStorage.setItem("homeCaseCarouselData", JSON.stringify(data));
  },

  // 从缓存恢复数据
  RESTORE_FROM_CACHE(state) {
    try {
      // 恢复首页轮播图数据
      const homeCarouselData = localStorage.getItem("homeCarouselData");
      if (homeCarouselData) {
        state.homeCarouselData = JSON.parse(homeCarouselData);
      }

      // 恢复产品中心轮播图数据
      const productCarouselData = localStorage.getItem("productCarouselData");
      if (productCarouselData) {
        state.productCarouselData = JSON.parse(productCarouselData);
      }

      // 恢复首页经典案例轮播图数据
      const homeCaseCarouselData = localStorage.getItem("homeCaseCarouselData");
      if (homeCaseCarouselData) {
        state.homeCaseCarouselData = JSON.parse(homeCaseCarouselData);
      }

      // 恢复行业分类列表数据
      const industryListData = localStorage.getItem("industryListData");
      if (industryListData) {
        state.industryListData = JSON.parse(industryListData);
      }
    } catch (error) {
      console.error("从缓存恢复数据失败:", error);
    }
  },
};

const actions = {
  // 获取首页轮播图数据
  async fetchHomeCarouselData({ commit, state }) {
    // 如果本地已有数据，直接返回
    if (state.homeCarouselData.length > 0) {
      return state.homeCarouselData;
    }

    try {
      // this._vm.$api 可以直接获取封装的所有vuex的模块api方法
      const response = await this._vm.$api.home.getHomeBannerAPI({
        type: 10, // 首页轮播图使用type=10
      });
      console.log('是否成功获取',response)

      if (response.code ==200) {
        const carouselData = response.rows || [];
        // 处理轮播图数据，添加按钮文本
        carouselData.forEach((item) => {
          item.primaryBtnText = "立即创建";
          item.secondaryBtnText = "立即咨询";
        });
        //   首页轮播图和产品中心顶部轮播图暂时用一个数据
        // 提交更新到state
        commit("SET_HOME_CAROUSEL_DATA", carouselData);
        // 提交更新到state
        commit("SET_PRODUCT_CAROUSEL_DATA", carouselData);
        return carouselData;
      } else {
        console.error("获取首页轮播图失败:", response.msg);
        throw new Error(response.msg || "获取首页轮播图失败");
      }
    } catch (error) {
      console.error("获取首页轮播图异常:", error);
      throw error;
    }
  },

  // 获取产品中心轮播图数据  暂时阐述后续需要打开
  //   async fetchProductCarouselData({ commit, state }) {
  //     // 检查缓存是否有效（5分钟内）
  //     const cacheValidTime = 5 * 60 * 1000;
  //     if (
  //       Date.now() - state.cacheTimestamps.productCarousel < cacheValidTime &&
  //       state.productCarouselData.length > 0
  //     ) {
  //       return state.productCarouselData;
  //     }

  //     try {
  //       // 产品中心轮播图也使用type=10，与首页轮播图共享同一批数据
  //       const response = await this._vm.$api.home.getHomeBannerAPI({
  //         type: 10,
  //       });

  //       if (response.status === 200) {
  //         const carouselData = response.data.rows || [];
  //         // 处理轮播图数据，添加按钮文本
  //         carouselData.forEach((item) => {
  //           item.primaryBtnText = "立即创建";
  //           item.secondaryBtnText = "立即咨询";
  //         });
  //         commit("SET_PRODUCT_CAROUSEL_DATA", carouselData);
  //         return carouselData;
  //       } else {
  //         console.error("获取产品中心轮播图失败:", response.msg);
  //         throw new Error(response.msg || "获取产品中心轮播图失败");
  //       }
  //     } catch (error) {
  //       console.error("获取产品中心轮播图异常:", error);
  //       throw error;
  //     }
  //   },

  // 获取首页经典案例轮播图数据
  async fetchHomeCaseCarouselData({ commit, state }) {
    // 如果本地已有数据，直接返回
    if (state.homeCaseCarouselData.length > 0) {
      return state.homeCaseCarouselData;
    }

    try {
      const response = await this._vm.$api.home.getHomeBannerAPI({
        type: 20, // 经典案例使用type=20
      });
      console.log('vuex中获取经典案例轮播图数据成功', response)
      if (response.code == 200) {
        const caseCarouselData = response.rows || [];
        commit("SET_HOME_CASE_CAROUSEL_DATA", caseCarouselData);
        return caseCarouselData;
      } else {
        console.error("获取经典案例轮播图失败:", response.msg);
        throw new Error(response.msg || "获取经典案例轮播图失败");
      }
    } catch (error) {
      console.error("获取经典案例轮播图异常:", error);
      throw error;
    }
  },

  // 获取行业分类列表数据
  async fetchIndustryListData({ commit, state }) {
    // 如果本地已有数据，直接返回
    if (state.industryListData.length > 0) {
      return state.industryListData;
    }

    try {
      const response = await this._vm.$api.product.getCompanyIndustryWxListAPI({
        parentld: 0,
      });
       console.log('vuex中获取行业分类列表', response)
      if (response.code === 200) {
        const industryData = response.data || [];
        commit("SET_INDUSTRY_LIST_DATA", industryData);
        return industryData;
      } else {
        console.error("获取行业分类列表失败:", response.msg);
        throw new Error(response.msg || "获取行业分类列表失败");
      }
    } catch (error) {
      console.error("获取行业分类列表异常:", error);
      throw error;
    }
  },

  // 登录成功后获取所有必要的数据
  async fetchAllDataAfterLogin({ dispatch }) {
    try {
      // 并行获取所有数据
      const [homeCarousel, homeCaseCarousel, industryList] = await Promise.all([
        // 首页轮播图
        dispatch("fetchHomeCarouselData"),
        // 首页经典案例轮播图
        dispatch("fetchHomeCaseCarouselData"),
        // 行业分类列表
        dispatch("fetchIndustryListData"),
      ]);

      return {
        homeCarousel,
        homeCaseCarousel,
        industryList,
      };
    } catch (error) {
      console.error("登录后获取数据失败:", error);
      // 即使部分数据获取失败，也不影响登录流程
      return null;
    }
  },
};

const getters = {
  // 获取首页轮播图数据
  getHomeCarouselData: (state) => state.homeCarouselData,
  // 获取产品中心轮播图数据
  getProductCarouselData: (state) => state.productCarouselData,
  // 获取首页经典案例轮播图数据
  getHomeCaseCarouselData: (state) => state.homeCaseCarouselData,
  // 获取行业分类列表数据
  getIndustryListData: (state) => state.industryListData,
  // 检查首页轮播图数据是否存在
  hasHomeCarouselData: (state) => state.homeCarouselData.length > 0,
  // 检查首页经典案例轮播图数据是否存在
  hasHomeCaseCarouselData: (state) => state.homeCaseCarouselData.length > 0,
  // 检查行业分类数据是否存在
  hasIndustryListData: (state) => state.industryListData.length > 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
